<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol sm="12" xs="12" md="6" lg="6" xl="2">
        <BaseInput
          :options="codeInput.options"
          :data="codeInput.data"
          :listener="codeInput.listener"
        />
      </CCol>
      <CCol sm="12" xs="12" md="6" lg="6" xl="2">
        <BaseInput
          :options="nameInput.options"
          :data="nameInput.data"
          :listener="nameInput.listener"
        />
      </CCol>
      <!-- <CCol sm="12" xs="12" md="6" lg="6" xl="2">
        <BaseSelect
          :options="isActiveSelect.options"
          :data="isActiveSelect.data"
          ref="isActive"
        >
        </BaseSelect>
      </CCol> -->
      <CCol >
        <CButton
          style="float: right;margin-left: 5px;"
          color="primary"
          v-c-tooltip.hover="'Tìm kiếm'"
          class="btn-action-primary"
          @click="loadDataMainTable(true)">
          <i class="fa fa-search"></i>&nbsp;&nbsp; Tìm kiếm
        </CButton>
        <CButton
          style="float: right;"
          color="primary"
          v-c-tooltip.hover="'Thêm mới'"
          class="btn-action-primary"
          @click="$router.push('/sale-program-management/add')"
        >
          <i class="fa fa-plus"></i>&nbsp;&nbsp; Thêm mới
        </CButton>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >

          <template #stt="{index}">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          
          <template #discount="{item}">
            <td>
              <span>{{ item.discount + "%" }}</span>
            </td>
          </template>

          <template #fromDate="{item}">
            <td>
              {{ $helper.formatDateDDMMYYYY(item.fromDate) }}
            </td>
          </template>

          <template #toDate="{item}">
            <td>
              {{ $helper.formatDateDDMMYYYY(item.toDate) }}
            </td>
          </template>

          <template #active="{item}">
            <td>
              <span v-if="item.active == false" class="dot-custom dot-danger">Không hoạt động</span>
              <span v-else-if="item.active == true" class="dot-custom dot-success">Hoạt động</span>
            </td>
          </template>


          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton color="info"
                         variant="outline"
                         v-c-tooltip.hover="'Cập nhật'"
                         square
                         size="sm"
                         @click="$router.push(`/sale-program-management/update/${item.id}`)">
                  <CIcon name="cil-pencil"/>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xóa'"
                  @click=" setupSelectOneAction('delete_one', item.id, item.name)">
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <ModalConfirm
      :actionTypeMapping="actionData.actionTypeMapping"
      ref="actionModal"
    >
    </ModalConfirm>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2";

export default {
  name: "SaleProgramList",
  components: {BaseTable, ModalConfirm, BaseInput, BaseSelect},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    var that = this;
    var actionTypeMapping = new Map();
    actionTypeMapping.set("delete_one", {
      url: "/sale-program/deleteById",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "chương trình khuyến mại",
          that.actionData.model.saleProgramSelectedName
        );
      },
      dataSubmit: function () {
        return {
          id: that.actionData.model.saleProgramSelectedId
        };
      },
      successCallback: function () {
        that.showSuccessMsg({
          message: "Xóa chương trình khuyến mại thành công"
        });
        that.loadDataMainTable();
      },
      isJsonContentType: false
    });

    return {
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          saleProgramSelectedName: null,
          saleProgramSelectedId: null,
        }
      },
      codeInput: {
        options: {
          placeholder: "Mã chương trình khuyến mại",
          label: 'Mã chương trình khuyến mại'
        },
        data: {
          name: "code",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      nameInput: {
        options: {
          placeholder: "Tên chương trình khuyến mại",
          label: 'Tên chương trình khuyến mại'
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      isActiveSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',
        },
        data: {
          name: "active",
          items: [
            {key: "null", value: "Tất cả trạng thái"},
            {key: "true", value: "Hoạt động"},
            {key: "false", value: "Không hoạt động"},
          ],
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            // {key: "checkbox", label: "#"},
            {key: "stt", label: "STT"},
            {key: "code", label: "Mã chương trình khuyến mại"},
            {key: "name", label: "Tên chương trình khuyến mại"},
            {key: "discount", label: "Khuyến mại %"},
            {key: "fromDate", label: "Từ ngày"},
            {key: "toDate", label: "Đến ngày"},
            // {key: "active", label: "Trạng thái"},
            {key: "action", label: "Thao tác"}
          ],
          slots: ["checkbox", "stt", "active", "action", "toDate", "fromDate", "discount"],
          pageSize: 20
        },
        dataSource: {
          url: "/sale-program/pageSaleProgram",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data)
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      }
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    setupSelectOneAction: function (actionTypeKey, categoryId, saleProgramSelectedName) {
      var actionData = this.actionData.model;
      actionData.saleProgramSelectedName = saleProgramSelectedName || null;
      actionData.saleProgramSelectedId = categoryId || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    setupSelectMoreAction: function (actionTypeKey) {
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    }
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
